import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import React, { ReactNode } from 'react';
import { IconButton, Label, RegularButton, SelectionGroupItem, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import {
  selectionGroupItem,
  type,
  label,
  cardContent,
  cardContentStatic,
  cardTextWrapper,
  cardIcon,
} from './styles';
import { AddressSheetItemDisplay, AddressSheetItemType } from './utils';
import { cx } from 'linaria';

interface SelectionGroupAddressItemProps {
  value: AddressSheetItemType;
  name: string;
  description: string;
  priceText: string | undefined;
  addressDisplay: AddressSheetItemDisplay | null;
  icon: ReactNode;
  showIcon: boolean;
  onCardClick: (value: AddressSheetItemType, element: HTMLElement) => void;
}

export const SelectionGroupAddressItem = ({
  value,
  name,
  priceText,
  description,
  addressDisplay,
  icon,
  showIcon,
  onCardClick,
}: SelectionGroupAddressItemProps) => {
  const { t } = useTranslation();
  const isRegion = value === FAVORITE_DELIVERY_TYPE.REGION;

  if (!addressDisplay) return null;

  return (
    <SelectionGroupItem className={selectionGroupItem} value={value}>
      <div className={type}>
        <Typography size="body_accent" variant="m">
          {name}
        </Typography>
        {priceText && (
          <Label
            background={value === FAVORITE_DELIVERY_TYPE.HOME_DELIVERY ? 'accent-light' : 'success-light'}
            className={label}
          >
            {priceText}
          </Label>
        )}
      </div>
      <Typography size="caption" variant="minor" color="text-secondary">
        {description}
      </Typography>
      <RegularButton
        className={cx(cardContent, !isRegion && cardContentStatic)}
        data-qa="address-card-content"
        variant="pseudo"
        onClick={
          isRegion
            ? (event) => {
                event.stopPropagation();
                onCardClick(value, event.currentTarget);
              }
            : undefined
        }
      >
        <div className={cardTextWrapper}>
          <Typography size="body_long" variant="m">
            {addressDisplay.primary}
          </Typography>

          {addressDisplay.secondary && (
            <Typography size="caption" variant="minor" color="text-secondary">
              {addressDisplay.secondary}
            </Typography>
          )}
        </div>

        {showIcon && (
          <IconButton
            className={cardIcon}
            as="div"
            variant="primary"
            size="l"
            label={t('header.main.favorite-address.address-menu.actions.edit')}
            onClick={(event) => {
              event.stopPropagation();
              onCardClick(value, event.currentTarget);
            }}
          >
            {icon}
          </IconButton>
        )}
      </RegularButton>
    </SelectionGroupItem>
  );
};
